import React from 'react'
import { createBrowserHistory } from 'history'
import { ReactPlugin, useAppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights, ICustomProperties } from '@microsoft/applicationinsights-web'
import Env from './Env'
import { UserInfo } from './services'
import { useAppSelector } from './stores'

const browserHistory = createBrowserHistory()
export const insightsPlugin = new ReactPlugin()
export function startApplicationInsights() {
  if (Env.AZURE_APPLICATION_INSIGHTS_CONNECTION_STRING === '') {
    console.log('アプリケーションログが無効の状態で動作します。')
    return
  }

  const insights = new ApplicationInsights({
    config: {
      connectionString: Env.AZURE_APPLICATION_INSIGHTS_CONNECTION_STRING,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      correlationHeaderExcludePatterns: [/(?:stg-|test-|test-jpw-)?auth.x-grab.net/],
      loggingLevelConsole: 1,

      extensions: [insightsPlugin],
      extensionConfig: {
        [insightsPlugin.identifier]: { history: browserHistory }
      }
    }
  })
  insights.loadAppInsights()
}

const includeTelemetryAttributeNames: Array<keyof UserInfo> = [
  'company_chief_type',
  'company_name',
  'company_register_type',
  'family_name',
  'given_name',
  'locale',
  'name',
  'user_register_type',
  'xgrab_company_id',
  'xgrab_user_id',
  'zoneinfo'
]
export function extractTelemetryAttributes(user: UserInfo, base: ICustomProperties | null = null): ICustomProperties {
  const props = base ?? {}
  return includeTelemetryAttributeNames.reduce((prop, key) => {
    prop[key] = user[key]
    return prop
  }, props)
}

export function useApplicationInsightsUserTelemetry() {
  const appInsights = useAppInsightsContext()
  const userInfo = useAppSelector(x => x.common.userInfo)

  React.useEffect(() => {
    if (userInfo != null && appInsights.isInitialized()) {
      insightsPlugin.core.addTelemetryInitializer(item => {
        item.data = extractTelemetryAttributes(userInfo, item)
      })
    }
  }, [userInfo])
}
